module.exports = __webpack_public_path__ + "static/img/coin-off.eceaade7.png";